import types from './types';

export const fetchIvrAIAgentFunctions = () => ({
  type: types.FETCH_IVR_AI_AGENT_FUNCTIONS,
});
export const fetchIvrAIAgentFunctionsSuccess = (data) => ({
  type: types.FETCH_IVR_AI_AGENT_FUNCTIONS_SUCCESS,
  payload: data,
});
export const fetchIvrAIAgentFunctionsFailure = () => ({
  type: types.FETCH_IVR_AI_AGENT_FUNCTIONS_FAILURE,
});

export const searchIvrAIAgentFunctions = ({ page, limit, search }) => ({
  type: types.SEARCH_IVR_AI_AGENT_FUNCTIONS,
  payload: { page, limit, search },
});
export const searchIvrAIAgentFunctionsSuccess = (data) => ({
  type: types.SEARCH_IVR_AI_AGENT_FUNCTIONS_SUCCESS,
  payload: data,
});
export const searchIvrAIAgentFunctionsFailure = () => ({
  type: types.SEARCH_IVR_AI_AGENT_FUNCTIONS_FAILURE,
});

export const createIvrAIAgentFunction = (data, callback) => ({
  type: types.CREATE_IVR_AI_AGENT_FUNCTION,
  payload: { data, callback },
});
export const createIvrAIAgentFunctionSuccess = (data) => ({
  type: types.CREATE_IVR_AI_AGENT_FUNCTION_SUCCESS,
  payload: data,
});
export const createIvrAIAgentFunctionFailure = () => ({
  type: types.CREATE_IVR_AI_AGENT_FUNCTION_FAILURE,
});

export const updateIvrAIAgentFunction = (data, callback) => ({
  type: types.UPDATE_IVR_AI_AGENT_FUNCTION,
  payload: { data, callback },
});
export const updateIvrAIAgentFunctionSuccess = (data) => ({
  type: types.UPDATE_IVR_AI_AGENT_FUNCTION_SUCCESS,
  payload: data,
});
export const updateIvrAIAgentFunctionFailure = () => ({
  type: types.UPDATE_IVR_AI_AGENT_FUNCTION_FAILURE,
});

export const deleteIvrAIAgentFunction = (id, callback) => ({
  type: types.DELETE_IVR_AI_AGENT_FUNCTION,
  payload: { id, callback },
});
export const deleteIvrAIAgentFunctionSuccess = (id) => ({
  type: types.DELETE_IVR_AI_AGENT_FUNCTION_SUCCESS,
  payload: { id },
});
export const deleteIvrAIAgentFunctionFailure = () => ({
  type: types.DELETE_IVR_AI_AGENT_FUNCTION_FAILURE,
});

export const fetchIvrAIAgentInstructions = () => ({
  type: types.FETCH_IVR_AI_AGENT_INSTRUCTIONS,
});
export const fetchIvrAIAgentInstructionsSuccess = (data) => ({
  type: types.FETCH_IVR_AI_AGENT_INSTRUCTIONS_SUCCESS,
  payload: data,
});
export const fetchIvrAIAgentInstructionsFailure = () => ({
  type: types.FETCH_IVR_AI_AGENT_INSTRUCTIONS_FAILURE,
});

export const searchIvrAIAgentInstructions = ({ page, limit, search }) => ({
  type: types.SEARCH_IVR_AI_AGENT_INSTRUCTIONS,
  payload: { page, limit, search },
});
export const searchIvrAIAgentInstructionsSuccess = (data) => ({
  type: types.SEARCH_IVR_AI_AGENT_INSTRUCTIONS_SUCCESS,
  payload: data,
});
export const searchIvrAIAgentInstructionsFailure = () => ({
  type: types.SEARCH_IVR_AI_AGENT_INSTRUCTIONS_FAILURE,
});

export const createIvrAIAgentInstruction = (data, callback) => ({
  type: types.CREATE_IVR_AI_AGENT_INSTRUCTION,
  payload: { data, callback },
});
export const createIvrAIAgentInstructionSuccess = (data) => ({
  type: types.CREATE_IVR_AI_AGENT_INSTRUCTION_SUCCESS,
  payload: data,
});
export const createIvrAIAgentInstructionFailure = () => ({
  type: types.CREATE_IVR_AI_AGENT_INSTRUCTION_FAILURE,
});

export const updateIvrAIAgentInstruction = (data, callback) => ({
  type: types.UPDATE_IVR_AI_AGENT_INSTRUCTION,
  payload: { data, callback },
});
export const updateIvrAIAgentInstructionSuccess = (data) => ({
  type: types.UPDATE_IVR_AI_AGENT_INSTRUCTION_SUCCESS,
  payload: data,
});
export const updateIvrAIAgentInstructionFailure = () => ({
  type: types.UPDATE_IVR_AI_AGENT_INSTRUCTION_FAILURE,
});

export const deleteIvrAIAgentInstruction = (id, callback) => ({
  type: types.DELETE_IVR_AI_AGENT_INSTRUCTION,
  payload: { id, callback },
});
export const deleteIvrAIAgentInstructionSuccess = (id) => ({
  type: types.DELETE_IVR_AI_AGENT_INSTRUCTION_SUCCESS,
  payload: { id },
});
export const deleteIvrAIAgentInstructionFailure = () => ({
  type: types.DELETE_IVR_AI_AGENT_INSTRUCTION_FAILURE,
});
